import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { createReducer, on, Action } from '@ngrx/store'

import * as EventTicketPurchasesActions from './event-ticket-purchases.actions'
import { EventTicketPurchaseEntity } from './event-ticket-purchases.models'

export const EVENT_TICKET_PURCHASES_FEATURE_KEY = 'eventTicketPurchases'

export interface EventTicketPurchasesState extends EntityState<EventTicketPurchaseEntity> {
  selectedId?: string // which EventTicketPurchases record has been selected
  loaded: boolean // has the EventTicketPurchases list been loaded
  error?: string | null // last known error (if any)
  amount?: number // ticket purchase amount
}

export interface EventTicketPurchasesPartialState {
  readonly [EVENT_TICKET_PURCHASES_FEATURE_KEY]: EventTicketPurchasesState
}

export const eventTicketPurchasesAdapter: EntityAdapter<EventTicketPurchaseEntity> =
  createEntityAdapter<EventTicketPurchaseEntity>({
    selectId: (eventTicketPurchase: EventTicketPurchaseEntity) => eventTicketPurchase.uuid,
  })

export const initialEventTicketPurchasesState: EventTicketPurchasesState = eventTicketPurchasesAdapter.getInitialState({
  // set initial required properties
  loaded: true,
  selectedId: '',
})

const eventTicketPurchasesReducer = createReducer(
  initialEventTicketPurchasesState,
  on(EventTicketPurchasesActions.updateAmount, (state, { amount }) => ({
    ...state,
    amount,
  })),
  on(
    EventTicketPurchasesActions.openPaymentDialog,
    EventTicketPurchasesActions.clearSelectedEventTicketPurchase,
    (state) => ({
      ...(state.selectedId ? eventTicketPurchasesAdapter.removeOne(state.selectedId, state) : state),
      selectedId: initialEventTicketPurchasesState.selectedId,
    }),
  ),
  on(EventTicketPurchasesActions.clearAmount, (state) => ({
    ...state,
    amount: initialEventTicketPurchasesState.amount,
  })),
  on(EventTicketPurchasesActions.placeEventTicketPurchaseSuccess, (state, action) => {
    const newState = eventTicketPurchasesAdapter.addOne(action.eventTicketPurchase, state)
    return { ...newState, selectedId: action.eventTicketPurchase.uuid }
  }),
  on(EventTicketPurchasesActions.syncEventTicketPurchaseSuccess, (state, action) =>
    eventTicketPurchasesAdapter.updateOne(action.update, state),
  ),
)

export function reducer(state: EventTicketPurchasesState | undefined, action: Action) {
  return eventTicketPurchasesReducer(state, action)
}
